module.exports = Promise.all([parcelRequire.load("5mUqE"), parcelRequire.load("1SPWO"), parcelRequire.load("fgb5H")]).then(() => parcelRequire('7rLTS'));